export default __webpack_public_path__ + "static/img_768_small3-2c9fbf0b62d56b7cc0868db75ab8ab7a.jpg";